// /* eslint-disable  */
import CloseIcon from '@mui/icons-material/Close';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Tooltip,
} from '@mui/material';
import React from 'react';

const useStyles = ({ height, noBottomPaddingForContent, modalHidden }) => ({
	paper: {
		// minWidth: ({ width }) => width,
		minHeight: height,
		// maxWidth: '80%'
		display: modalHidden ? 'none' : 'block',
	},
	actionButton: {
		marginRight: '10px',
	},
	dc: {
		padding: '8px 24px',
		paddingBottom: noBottomPaddingForContent ? 0 : '8px',
	},
	dt: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginRight: '16px',
	},
	title: {
		fontSize: '1.375rem',
		fontWeight: 400,
	},
	iconButton: (theme) => ({
		position: 'absolute',
		right: 12,
		top: 2,
		// eslint-disable-next-line no-magic-numbers
		color: theme.palette.grey[500],
	}),
	opComp: {
		position: 'absolute',
		right: 24,
		top: 8,
	},
});

const Modal = (props) => {
	const classes = useStyles(props);

	const getAriaAttribute = (att, id) => {
		if (props.dialogLabel) {
			return props.dialogLabel;
		}
		if (props.dialogTitle && typeof props.dialogTitle === 'string') {
			return `${props.dialogTitle.split(' ').join('-')}-${att ? att : ''}-${id ? id : ''}`;
		}
		return `customized-dialog-${att}`;
	};

	return (
		<div>
			<Dialog
				data-testid={props.dataTestId}
				sx={classes.paper}
				onClose={() => (!props.restrictClosing ? props.handleOpen(false) : null)}
				open={props.open}
				aria-labelledby={props.labelId}
				PaperProps={{
					role: 'dialog',
					// Props applied to the Modal (root)
					'aria-modal': 'true',
				}}
			>
				<div aria-hidden="true" tabIndex={0} aria-label={`${props.labelId} dialog`} />

				{props.dialogTitle && (
					<DialogTitle
						id={props.labelId}
						data-testid={getAriaAttribute('title', 'testid')}
						sx={classes.title}
					>
						{props.dialogTitle}
					</DialogTitle>
				)}
				{props.optionalComp && <Box sx={classes.opComp}>{props.optionalComp}</Box>}
				{props.showCancel && (
					<Tooltip title="Close Modal" sx={classes.tooltip}>
						<IconButton
							data-testid="modal-cancel-button"
							aria-label="Close Modal"
							onClick={() => (!props.restrictClosing ? props.handleOpen(false) : null)}
							sx={classes.iconButton}
						>
							<CloseIcon />
						</IconButton>
					</Tooltip>
				)}
				<DialogContent sx={classes.dc} id={`${props.labelId}-description`}>
					{props.dialogContent}
				</DialogContent>
				<DialogActions>
					{props.cancelButtonText && !props.hideCancelButton ? (
						<Button
							color="primary"
							data-testid={`${props.dataTestId}-Cancel`}
							onClick={props.onCancelButtonClick}
						>
							{props.cancelButtonText}
						</Button>
					) : null}
					{props.actionButtonText ? (
						<Button
							aria-label={props.actionButtonText}
							data-testid={props.actionButtonText}
							disabled={props.actionButtonDisabled}
							sx={classes.actionButton}
							variant="contained"
							color="primary"
							onClick={props.onActionButtonClick}
						>
							{props.actionButtonText}
						</Button>
					) : null}
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default Modal;
